<template>
  <div>
    <v-row no-gutters justify="start" align="center" class="content-header">
      <v-icon small color="accent" class="mr-2 font-weight-bold">notifications</v-icon>
      <span class="font-weight-bold primary--text">Notifications</span>
    </v-row>
    <v-row no-gutters justify="center" align="center" class="my-5" v-if="isFetchingMe">
      <v-progress-circular indeterminate color="primary darken-1" />
    </v-row>
    <template v-else>
      <n-card class="py-1 px-4">
        <v-row no-gutters justify="center" align="center">
          <v-col>
            <label>Notifications par email</label>
          </v-col>
          <v-switch v-model="hasEmailNotifications" />
        </v-row>
      </n-card>
      <n-card class="py-1 px-4 mt-4">
        <v-row no-gutters justify="center" align="center">
          <label>Notifications sur mobile</label>
          <v-spacer />
          <v-switch v-model="hasMobileNotifications" />
        </v-row>
        <div class="text-caption pb-2 text-center">
          Installez l'application sur votre appareil pour recevoir les notifications
        </div>
        <v-row no-gutters justify="center" align="center" class="pt-2 pb-4">
          <a href="https://apps.apple.com/us/app/indeego/id1564414006" target="_blank">
            <img src="@/assets/img/available-on-appstore.png" style="max-height: 50px;" />
          </a>
          <div class="px-6">&nbsp;</div>
          <a href="https://play.google.com/store/apps/details?id=app.indeego.indeego" target="_blank">
            <img src="@/assets/img/available-on-playstore.png" style="max-height: 50px;" />
          </a>
        </v-row>
      </n-card>
    </template>
  </div>
</template>

<script>
// import _ from 'lodash';
import { mapActions, mapState } from 'vuex';

export default {
  data: () => ({
    isFetchingMe: true,
    // hasEmailNotifications: false,
    // hasMobileNotifications: false,
    // me: {},
    // rules: {
    //   required: [value => !!value || `Ce champ est requis`],
    // },
    // isSavingMe: false,
    // isMeFormValid: true,
  }),
  computed: {
    hasEmailNotifications: {
      get() { return Boolean(this.me?.hasEmailNotifications); },
      set(hasEmailNotifications) {
        this.saveMe({
          ...this.me,
          hasEmailNotifications,
        });
      },
    },
    hasMobileNotifications: {
      get() { return Boolean(this.me?.hasMobileNotifications); },
      set(hasMobileNotifications) {
        this.saveMe({
          ...this.me,
          hasMobileNotifications,
        });
      },
    },
    ...mapState(`model/user`, [
      `me`,
    ]),
  },
  // watch: {
  //   storeMe(newValue) {
  //     this.me = newValue;
  //   },
  // },
  async beforeMount() {
    this.isFetchingMe = true;
    await this.fetchMe();
    this.isFetchingMe = false;
    // this.me = this.storeMe || {};
  },
  methods: {
    ...mapActions(`model/user`, [
      `fetchMe`,
      `saveMe`,
    ]),
    // async saveMe() {
    //   this.isSavingMe = true;
    //   await this.$store.dispatch(`model/user/saveMe`, this.me);
    //   this.$store.dispatch(`showSnackbar`, {
    //     color: `success`,
    //     message: `Informations enregistrées`,
    //   });
    //   this.isSavingMe = false;
    // },
  },
};
</script>
